module.exports = __webpack_public_path__ + "media/01.4e74f9b6.wav";